import { render, staticRenderFns } from "./ku-private.vue?vue&type=template&id=22634f4e&scoped=true"
var script = {}
import style0 from "./ku-private.vue?vue&type=style&index=0&id=22634f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22634f4e",
  null
  
)

export default component.exports